import dayjs from 'dayjs';
import React from 'react';
import { useFrontload } from 'react-frontload';
import Loading from '../../components/loading/loading';
import { useResponsive } from '../../hooks/use_responsive';
import { apiV1 } from '../../lib/api';
import { WaterbodySpeciesListPage } from './waterbody_species_list_page';

interface WaterbodySpeciesListPageContainerProps {
  urlSlug: string;
}

const WaterbodySpeciesListPageContainer = (props: WaterbodySpeciesListPageContainerProps) => {
  const { urlSlug } = props;

  const { isMobile } = useResponsive();

  const { data, frontloadMeta } = useFrontload(
    `WaterbodySpeciesListPageContainer:${urlSlug}`,
    async () => {
      try {
        const [waterbodyRes, newestFishingReportsRes, speciesSurveyDataRes] =
          await Promise.allSettled([
            apiV1.waterbodyFetch(urlSlug),
            apiV1.waterbodyFishingReportsFetch(urlSlug, {
              sort: 'newest',
              per_page: 1,
            }),
            apiV1.waterbodySpeciesSurveyDataFetch(urlSlug, {
              version: 'v1',
            }),
          ]);

        return {
          newestFishingReport:
            newestFishingReportsRes.status === 'fulfilled' &&
            newestFishingReportsRes.value.data.data.length > 0
              ? newestFishingReportsRes.value.data.data[0]
              : null,
          waterbodyDetail:
            waterbodyRes.status === 'fulfilled' ? waterbodyRes.value.data.data : null,
          waterbodySpeciesSurveyData:
            speciesSurveyDataRes.status === 'fulfilled'
              ? speciesSurveyDataRes.value.data.data
              : null,
        };
      } catch (e) {
        console.log(e);
      }
    }
  );

  const newestFishingReport = data?.newestFishingReport || null;
  const waterbodyDetail = data?.waterbodyDetail;
  const waterbodySpeciesSurveyData = data?.waterbodySpeciesSurveyData;

  const mostRecentFishingReportDate = newestFishingReport
    ? dayjs(newestFishingReport?.accepted_at).startOf('day')
    : null;

  if (frontloadMeta.pending) {
    return (
      <Loading text="Loading Waterbody Data" style={{ minHeight: isMobile ? '80dvh' : '40dvh' }} />
    );
  }

  if (!frontloadMeta.done || !waterbodyDetail || !waterbodySpeciesSurveyData) {
    return null;
  }

  return (
    <>
      <WaterbodySpeciesListPage
        mostRecentFishingReportDate={mostRecentFishingReportDate}
        waterbodyDetail={waterbodyDetail}
        waterbodySpeciesSurveyData={waterbodySpeciesSurveyData}
      />
    </>
  );
};
export default WaterbodySpeciesListPageContainer;
